import { render, staticRenderFns } from "./UnauthorizedAccessPage.vue?vue&type=template&id=b6d2d09c"
import script from "./UnauthorizedAccessPage.vue?vue&type=script&lang=ts"
export * from "./UnauthorizedAccessPage.vue?vue&type=script&lang=ts"
import style0 from "./UnauthorizedAccessPage.vue?vue&type=style&index=0&id=b6d2d09c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports